<template>
	<section>
		<!-- Section heading -->
		<h3 class="mb-4 text-xl font-medium text-white">
			{{ $t('personality_results.key-insights.heading') }}
		</h3>

		<div class="space-y-6">
			<div
				v-for="category in categories"
				:key="category.id"
				class="rounded-lg border border-[#313131]"
			>
				<div
					class="bg-grey-950 p-4 flex space-x-4 border-b border-[#313131]"
				>
					<div
						class="w-11 h-11 rounded-full bg-[#313131] flex items-center justify-center flex-shrink-0"
					>
						<Component :is="category.icon" />
					</div>

					<div>
						<h4 class="mb-1.5 leading-snug text-white">
							{{ category.heading }}
						</h4>

						<p class="mb-0 text-sm leading-none text-gray-300">
							{{ category.description }}
						</p>
					</div>
				</div>

				<div class="px-4 py-2">
					<ul v-if="hasInsights(category.id)" class="mb-0">
						<li
							v-for="insight in comparisonKeyInsights[
								category.id
							]"
							:key="insight.trait"
							class="flex items-center justify-between my-2"
						>
							<div class="flex">
								<BulletPoint />
								<p class="mb-0 text-gray-300">
									{{ insight.description }}
								</p>
							</div>

							<div
								class="text-xs rounded-full border text-gray-300 border-[#313131] py-1 px-2.5 ml-10 md:ml-20"
							>
								{{ insight.displayName }}
							</div>
						</li>
					</ul>

					<div v-else>
						<p class="mb-0 text-gray-300">
							{{ category.empty }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import personalityResults from '~/mixins/personalityResults'
import {
	IconCheckCircle,
	IconTrendingUp,
	IconAlertTriangle
} from '~/components/Icons'
import { BulletPoint } from '~/components/Typography'

export default {
	name: 'OverviewComparisonInsights',
	mixins: [personalityResults],
	components: {
		IconCheckCircle,
		IconTrendingUp,
		IconAlertTriangle,
		BulletPoint
	},
	props: {
		jobOfferData: {
			type: Object,
			default: () => {}
		},
		applicantData: {
			type: Object,
			default: () => {}
		},
		wheelMode: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			categories: [
				{
					id: 'strengths',
					icon: IconCheckCircle,
					heading: this.$t(
						'personality_results.comparison.insights.key-strengths.heading'
					),
					description: this.$t(
						'personality_results.comparison.insights.key-strengths.description'
					),
					empty: this.$t(
						'personality_results.comparison.insights.key-strengths.empty'
					)
				},
				{
					id: 'contributions',
					icon: IconTrendingUp,
					heading: this.$t(
						'personality_results.comparison.insights.contributions.heading'
					),
					description: this.$t(
						'personality_results.comparison.insights.contributions.description'
					),
					empty: this.$t(
						'personality_results.comparison.insights.contributions.empty'
					)
				},
				{
					id: 'needsAttention',
					icon: IconAlertTriangle,
					heading: this.$t(
						'personality_results.comparison.insights.needs-attention.heading'
					),
					description: this.$t(
						'personality_results.comparison.insights.needs-attention.description'
					),
					empty: this.$t(
						'personality_results.comparison.insights.needs-attention.empty'
					)
				}
			]
		}
	},
	methods: {
		hasInsights(categoryId) {
			return this.comparisonKeyInsights[categoryId].length > 0
		}
	}
}
</script>
